import {
  IPlanOverviewDetail,
  SubscriptionSource,
} from '@models/interfaces/user.interface';
import { COUNTRY_ID_VIETNAM } from '@utils/constants/countries.constants';
import { moneyFormatter } from '@components/subscription/helper/SubscriptionHelper';

export function isInAppPurchase(planDetail: IPlanOverviewDetail) {
  return (
    planDetail.subscription_source == SubscriptionSource.android ||
    planDetail.subscription_source == SubscriptionSource.ios
  );
}

export function priceWithCurrency(planDetail: IPlanOverviewDetail) {
  return moneyFormatter(
    planDetail.currency_code,
    planDetail.price * (1 + Number(planDetail.gst_rate ?? 0)),
  );
}

export function planName(planDetail: IPlanOverviewDetail) {
  if (
    planDetail.country_id == COUNTRY_ID_VIETNAM &&
    planDetail.subscription_plan_name === 'Home Edition'
  ) {
    return 'VN Home Edition';
  }
  return planDetail.subscription_plan_name;
}
